import { nlsfbNode, optLabel, STATUS, typeLabel, type BuildingDto, type IssueSummary } from "@klantpunt/shared";
import { locLabel } from "./filters";

const statusLabel = (k: string) => STATUS.find((s) => s.k === k)?.l ?? k;

/** CSV (puntkomma-gescheiden, UTF-8 met BOM) van de gefilterde lijst; kolommen zoals in het prototype. */
export function issuesCsv(list: IssueSummary[], b: BuildingDto): string {
  const rows: string[][] = [
    [
      "ID",
      "Prioriteit",
      "Status",
      "Titel",
      "Toelichting",
      "Hoofdverdieping",
      "Plekken",
      "Asset",
      "Type",
      "Element",
      "Elementnaam",
      "Gevaar",
      "Impact",
      "Verergert",
      "Omvang",
      "Oplosser",
      "Herkomst",
      "Taak",
      "Robaws",
      "Aangemaakt",
      "Bijgewerkt",
    ],
  ];
  for (const i of list) {
    const a = i.answers;
    const main = i.locations[0];
    rows.push([
      i.code,
      i.priority,
      statusLabel(i.status),
      i.title,
      i.description ?? "",
      b.floors.find((f) => f.id === main?.floorId)?.name ?? "",
      i.locations.map((l) => locLabel(b, l)).join("; "),
      b.assets.find((x) => x.id === i.installationId)?.name ?? "",
      typeLabel(a.type),
      i.elementCode ?? "",
      i.elementCode ? (nlsfbNode(i.elementCode)?.label ?? "") : "",
      optLabel("danger", a.danger),
      optLabel("impact", a.impact),
      optLabel("worsen", a.worsen),
      optLabel("size", a.size),
      optLabel("solver", a.solver),
      optLabel("origin", a.origin),
      i.taskCode ?? "",
      "",
      i.createdAt,
      i.updatedAt,
    ]);
  }
  return "﻿" + rows.map((r) => r.map((v) => `"${String(v ?? "").replace(/"/g, '""')}"`).join(";")).join("\r\n");
}

export function downloadCsv(csv: string, filename: string) {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}
